import { AUTH } from 'constants/api';
import axios from 'utils/axios';

export const userLoginRequest = async ({ email, password, isRefresh = false, hasCaptcha = false, groupId = null }) => {
    const response = await axios.post(
        AUTH.v2.loginRequest,
        {
            email,
            password,
            isRefresh,
            hasCaptcha,
            groupId
        },
        {
            withCredentials: true
        }
    );
    return response.data;
};

export const verifySession = async () => {
    const response = await axios.get(AUTH.v2.verifySession, {
        withCredentials: true
    });
    return response.data;
};

export const verifyLoginOtp = async ({
    email,
    otp,
    method,
    hasCaptcha = false,
    otpSessionKey,
    isKeepMeLogin = false,
    groupId = null,
    initialLoginToken = ''
}) => {
    const response = await axios.post(AUTH.v2.verifyLoginOtp, {
        email,
        otp,
        method,
        hasCaptcha,
        otpSessionKey,
        isKeepMeLogin,
        groupId,
        initialLoginToken
    });
    return response.data;
};

export const logout = async (data) => {
    const response = await axios.post(AUTH.v2.logout, data, { withCredentials: true });
    return response.data;
};

export const resendOtp = async (id) => {
    const response = await axios.post(AUTH.v2.resendOtp, { id, system: 'lln' }, { withCredentials: false });
    return response.data;
};

export const validateResetPasswordToken = async (resetPasswordToken, groupId = '') => {
    const response = await axios.get(AUTH.v2.validateResetPasswordToken, { params: { resetPasswordToken, groupId } });
    return response.data;
};

export const changePassword = async (userId, password, groupId = '') => {
    const response = await axios.post('/api/v2/auth/change-password', { userId, password, groupId });
    return response.data;
};

export const userValidateInitLogin = async (email, token) => {
    try {
        const response = await axios.post(AUTH.v2.verifyInitialLogin, {
            email,
            token
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// set logged in user password
export const setPassword = async (password) => {
    try {
        const response = await axios.post(AUTH.v2.setPassword, { password }, { withCredentials: true });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const reInitDeployment = async (deployment) => {
    try {
        const response = await axios.post(AUTH.v2.reInitDeployment, { deployment }, { withCredentials: true });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
